import Vue from 'vue';

const success = (context, response) => {
  context.success = response.data.msg;
  toastr.success(response.data.msg);
  context.mark_as_read_messages(context.$route.params.id);
  context.get_messages(context.$route.params.id);
  context.message.text = '';
  context.messagesLoading = false;
};

const failed = (context, error) => {
  if (error.response) {
    if (error.response.data && error.response.data.type && error.response.data.type === 'billing_empty') {
      toastr.error(context.$t('messages.index.billing_empty'));
    } else {
      context.showToasterError(error);
    }
  }
  context.messagesLoading = false;
};

export default (context, message) => {
  return Vue.$http.post('/sms/send', message)
    .then(response => {
      if(response && response.status === 200) {
        success(context, response);
      }
    }).catch(error => {
      failed(context, error);
    });
}



// WEBPACK FOOTER //
// ./src/app/services/message/sendSms.js